import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Loading from "../../components/Loading";

export default function CertificadosList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [certificados, setCertificados] = useState([]);
  const [loading, setLoading] = useState(true);

  const expiracao = searchParams.get("expiracao");

  const getTitulo = () => {
    switch (expiracao) {
      case "semana":
        return "Certificados que expiram essa semana";
      case "30dias":
        return "Certificados que expiram em 30 dias";
      default:
        return "Certificados";
    }
  };

  useEffect(() => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API}/certificadoempresa`, {
      params: { expiracao }
    })
      .then((res) => {
        setCertificados(res.data.data || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [expiracao]);

  const getStatusCertificado = (dataValidade) => {
    const hoje = new Date();
    const validade = new Date(dataValidade);
    const diasRestantes = Math.ceil((validade - hoje) / (1000 * 60 * 60 * 24));

    if (diasRestantes < 0) {
      return { label: "Expirado", className: "bg-red-100 text-red-700", dias: diasRestantes };
    } else if (diasRestantes <= 7) {
      return { label: `${diasRestantes} dias`, className: "bg-red-100 text-red-700", dias: diasRestantes };
    } else if (diasRestantes <= 30) {
      return { label: `${diasRestantes} dias`, className: "bg-yellow-100 text-yellow-700", dias: diasRestantes };
    } else {
      return { label: `${diasRestantes} dias`, className: "bg-green-100 text-green-700", dias: diasRestantes };
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-xl font-bold">{getTitulo()}</h1>
          <p className="text-sm text-gray-500">
            {certificados.length} certificado(s) encontrado(s)
          </p>
        </div>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-4 py-2 text-sm rounded border hover:bg-gray-50"
        >
          Voltar ao Dashboard
        </button>
      </div>

      <div className="bg-white rounded-lg shadow">
        {loading ? (
          <Loading />
        ) : certificados.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            Nenhum certificado encontrado
          </div>
        ) : (
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Documento</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Validade</th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {certificados.map((cert) => {
                const status = getStatusCertificado(cert.dataValidade);
                return (
                  <tr key={cert.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <div className="flex flex-col">
                        <span className="font-medium text-gray-800">{cert.empresaNome}</span>
                        {cert.empresaNomeFantasia && (
                          <span className="text-xs text-gray-500">{cert.empresaNomeFantasia}</span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {cert.empresaDocumento || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {new Date(cert.dataValidade).toLocaleDateString("pt-BR")}
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className={`px-3 py-1 text-xs font-medium rounded-full ${status.className}`}>
                        {status.label}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <button
                        onClick={() => navigate(`/clientes/${cert.empresaClienteId}`)}
                        className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
                        title="Ver cliente"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}